// LinkedIn Insight Tag — event helpers.
//
// The base Insight Tag (index.html) already tracks page views on its own —
// LinkedIn's SDK does not need a manual "page view" call, unlike TikTok's
// older pattern, so there is no per-route tracking code needed for that part.
//
// This file exists ONLY for CONVERSION tracking on "Book a Free Strategy
// Call" — and that requires custom code because LinkedIn's no-code Website
// Actions conversion type matches on a *distinct URL being visited*. Every
// "Book a Free Strategy Call" CTA on this site is an anchor link to
// `#inquiry` on the same page (no URL change, no page reload), and the
// inquiry form's own "Message received" success state is likewise shown
// in place, not on a new URL. Neither of those is something LinkedIn's
// point-and-click conversion rules can detect — so a real conversion here
// needs an explicit `window.lintrk('track', { conversion_id })` call.
//
// HOW TO ACTIVATE:
// 1. In Campaign Manager: Measure (or Data) → Conversion Tracking →
//    Create conversion → Website action → attach it to this Insight Tag
//    (Partner ID 9485810). Do this once for "Strategy Call CTA Click" and
//    once for "Strategy Call Form Submitted" (or just one, your call).
// 2. Copy the numeric Conversion ID LinkedIn gives you into the two
//    constants below.
// 3. Until those are filled in, every call in this file safely no-ops —
//    it will NOT send a malformed conversion_id to LinkedIn.
//
// Official reference: https://www.linkedin.com/help/lms/answer/a415981

const CLICK_CONVERSION_ID = null // e.g. 123456 — from "Strategy Call CTA Click" conversion
const CONTACT_CONVERSION_ID = null // e.g. 123457 — from "Strategy Call Form Submitted" conversion

function lintrkCall(conversionId) {
  if (typeof window === 'undefined' || !window.lintrk) return
  if (!conversionId) return // not configured yet in Campaign Manager — no-op, not an error
  try {
    window.lintrk('track', { conversion_id: conversionId })
  } catch {
    // Never let a tracking failure break the feature it's attached to.
  }
}

/**
 * Fires when a primary "Book a Free Strategy Call" CTA is clicked.
 * Wired into the same Button instances already flagged with `ttqTrack`
 * (Hero, Navbar, FinalCTA, CampaignHero, InsightArticle) — see Button.jsx.
 * No personal data is sent; this is a conversion count only.
 */
export function trackClickButton() {
  lintrkCall(CLICK_CONVERSION_ID)
}

/**
 * Fires once per genuinely successful inquiry-form submission — same
 * success branch as TikTok's trackContact in tiktokPixel.js, deliberately
 * not fired from the honeypot's faked-success branch. No form field
 * values (name, email, phone, business details) are ever passed to
 * LinkedIn — only the fact that a conversion happened.
 */
export function trackContact() {
  lintrkCall(CONTACT_CONVERSION_ID)
}
